export class Printers {
    public Active: boolean;
    constructor(
        public PrinterID: number,
        public IPAddress: string,
        public HostName: string
    ) {
        this.Active = true;
    }
  }